export default __webpack_public_path__ + "static/media/avatar-bts-v.2eacfa4b.png";